import { render, staticRenderFns } from "./SettingsCustomWebpageView.vue?vue&type=template&id=1ac7f7a2&scoped=true&"
import script from "./SettingsCustomWebpageView.vue?vue&type=script&lang=js&"
export * from "./SettingsCustomWebpageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac7f7a2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VIcon,VRow,VSpacer,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ac7f7a2')) {
      api.createRecord('1ac7f7a2', component.options)
    } else {
      api.reload('1ac7f7a2', component.options)
    }
    module.hot.accept("./SettingsCustomWebpageView.vue?vue&type=template&id=1ac7f7a2&scoped=true&", function () {
      api.rerender('1ac7f7a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/SettingsCustomWebpageView.vue"
export default component.exports